<template>
	<router-view />
</template>